import type * as React from "react";
import { cn } from "@/lib/utils";

interface DashboardPageHeaderProps {
	title: React.ReactNode;
	description?: React.ReactNode;
	className?: string;
	children?: React.ReactNode;
}

export function DashboardPageHeader({
	title,
	description,
	className,
	children,
}: DashboardPageHeaderProps) {
	return (
		<header className={cn("space-y-1", className)}>
			<h1 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
				{title}
			</h1>
			{description ? (
				<p className="max-w-xl text-sm leading-6 text-muted-foreground">
					{description}
				</p>
			) : null}
			{children}
		</header>
	);
}
